import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'lodash.flowright';

import AlbumFolderSearchResult from '../AlbumFolderSearchResult';
import AlbumSearchResult from '../AlbumSearchResult';
import ProOnboardingCTAModal from '../../../UserPage/components/ProUserPage/components/ProOnboardingCTA/modal';
import { openModal as openModalAction } from '../../../../../../actions/modal-actions';
import { USERPAGE_PRO_ONBOARDING_MODAL } from '../../../../../../constants/modals';
import { ALBUM_TYPE } from '../../../../../../constants/albums';
import inIframe from '../../../../../../util/in-iframe';
import { isAlbumIndividual } from '../../../../../../util/album';

const propTypes = {
  nameSearchField: PropTypes.string,
  searchResults: PropTypes.arrayOf(PropTypes.object).isRequired,
  openModal: PropTypes.func.isRequired,
  authenticated: PropTypes.bool.isRequired,
};

const HIERARCHY_ITEM_TYPE = {
  ALBUM: 'ALBUM',
  ALBUM_FOLDER: 'ALBUM_FOLDER',
};

const AlbumSearchResultListing = ({
  nameSearchField,
  searchResults,
  openModal,
  authenticated,
}) => {
  const resultClasses = 'col-lg-4 col-sm-6 col-12 mb-6';

  return (
    <Fragment>
      <div className="row">
        {searchResults.map(result => {
          if (result.item_type === HIERARCHY_ITEM_TYPE.ALBUM_FOLDER) {
            return (
              <div key={result.album_folder.id} className={resultClasses}>
                <AlbumFolderSearchResult
                  albumFolder={result.album_folder}
                  nameSearchField={nameSearchField}
                  authenticated={authenticated}
                  onClick={
                    result.album_folder.album_type === ALBUM_TYPE.PRO
                      ? event => {
                          openModal(USERPAGE_PRO_ONBOARDING_MODAL, {
                            hierarchyItem: {
                              ...result,
                              name: result.album_folder.name,
                            },
                            // If available, skips directly to WG
                            requireUserInteraction: false,
                            forcedTopPosition: inIframe()
                              ? event.target.getBoundingClientRect().top
                              : undefined,
                          });
                        }
                      : undefined
                  }
                />
              </div>
            );
          }

          if (result.item_type === HIERARCHY_ITEM_TYPE.ALBUM) {
            return (
              <div key={result.album.id} className={resultClasses}>
                <AlbumSearchResult
                  album={result.album}
                  authenticated={authenticated}
                  onClick={
                    result.album.album_type === ALBUM_TYPE.PRO &&
                    isAlbumIndividual(result.album)
                      ? event => {
                          openModal(USERPAGE_PRO_ONBOARDING_MODAL, {
                            hierarchyItem: {
                              ...result,
                              name: result.album.name,
                            },
                            // If available, skips directly to WG
                            requireUserInteraction: false,
                            forcedTopPosition: inIframe()
                              ? event.target.getBoundingClientRect().top
                              : undefined,
                          });
                        }
                      : undefined
                  }
                />
              </div>
            );
          }

          return null;
        })}
      </div>

      <ProOnboardingCTAModal />
    </Fragment>
  );
};

AlbumSearchResultListing.propTypes = propTypes;

const mapDispatchToProps = {
  openModal: openModalAction,
};

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AlbumSearchResultListing,
);
